import { render } from "./ListUnduhanView.vue?vue&type=template&id=42edcf3a"
import script from "./ListUnduhanView.vue?vue&type=script&lang=js"
export * from "./ListUnduhanView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__